import alt from 'components/Dispatcher';

/**
 * FileUploadCallCardActions are actions related to the state changes in <FileUploadCallCard />
 */
class FileUploadCallCardActions {
  constructor() {
    this.generateActions(
      'setLibraryTagDropdownOpened',
      'toggleScorecard',
      'toggleScorecardResults'
    );
  }
}

export default alt.createActions(FileUploadCallCardActions);
